/* v3-edge-fade.js — tell a horizontal scroller which of its edges still has
   something beyond it.

   SAMEER, ROUND 5: "When scrolled to the last item, the shadow is still
   visible, making it look like there is more content to scroll. The same issue
   occurs with the colour chips on the product pages ... Ideally, when scrolled
   to the last item, the shadow should disappear. Alternatively, it can shift to
   the opposite side."

   He is right, and the cause is that neither fade ever knew anything. Both were
   static CSS pseudo-elements. The only thing that removed either was a viewport
   media query — 880px on the announcement bar, 768px on the chip row — so at
   every width below that the fade painted whether the row had scrolled, could
   scroll, or was already finished. The chip row's own comment said so in as
   many words: "The fade is unconditional."

   Measured before building this, at 390px:
     announcement bar   scrollWidth 843, clientWidth 390 — fade identical at
                        scrollLeft 0 and at scrollLeft 453, the maximum
     colour chips       fade identical at both ends; and worse, 4 of Arbi's 11
                        colourways LOAD at the maximum scroll, because the buy
                        box centres the current chip and the centre clamps to
                        the end. Those shoppers arrive at a finished row being
                        told there is more.
     size chart         118px of overflow at 390 and NO CUE OF ANY KIND — no
                        fade, no marks, nothing. Nobody reported it. CLAUDE.md
                        calls the millimetre chart and the size finder the
                        entire fit answer, so a shopper who does not know the
                        table scrolls does not get the answer.

   His alternative — "shift to the opposite side" — is the right shape, with one
   refinement: the middle of a scroll has content beyond BOTH edges, so it
   should show both. Four states, one attribute:

     none     the row does not overflow          no fade
     start    at the left end                    right fade only
     middle   scrolled, not finished             both fades
     end      at the right end                   left fade only

   NO-JAVASCRIPT PARITY IS DELIBERATE. The unconditional ::after stays exactly
   as it was and is the attribute-less default, so a page where this script does
   not run is no worse than the page shipped yesterday. The states only ever
   take a fade away or add the mirrored one. That also covers the boot-order
   case on the product page: v3-buybox.js scrolls the chip row on
   DOMContentLoaded and both scripts are deferred, so whichever lands second
   must still resolve — hence the explicit initial pass rather than relying on
   the scroll event that scroll fires.

   THE 1px TOLERANCES ARE NOT SLOP. Browser zoom and some trackpads give
   fractional scrollLeft; without them the end state flickers between `middle`
   and `end` on the last pixel.

   FONTS MOVE THE FIT POINT. The announcement row is 843px wide in the fallback
   face and 872px in Archivo — a 29px swing that changes whether it overflows at
   all in the 850-880 band. So the state is recomputed after document.fonts
   settles, which the media-query version could never do. */
(function () {
  'use strict'

  var HOSTS = '[data-v3-edge-host]'

  function scrollerFor (host) {
    return host.querySelector('[data-v3-edge-scroller]') || host
  }

  function state (el) {
    var max = el.scrollWidth - el.clientWidth
    if (max <= 1) return 'none'
    var x = el.scrollLeft
    if (x <= 1) return 'start'
    if (x >= max - 1) return 'end'
    return 'middle'
  }

  function wire (host) {
    var sc = scrollerFor(host)
    var frame = 0

    function apply () {
      frame = 0
      var next = state(sc)
      if (host.getAttribute('data-v3-edge') !== next) {
        host.setAttribute('data-v3-edge', next)
      }
    }
    function schedule () {
      if (frame) return
      frame = requestAnimationFrame(apply)
    }

    sc.addEventListener('scroll', schedule, { passive: true })
    window.addEventListener('resize', schedule, { passive: true })

    // The chip row's contents change with the colourway count and the chart's
    // with the style, so width changes without the viewport changing.
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(schedule).observe(sc)
    }

    apply()

    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(apply).catch(function () {})
    }
  }

  function boot () {
    var hosts = document.querySelectorAll(HOSTS)
    for (var i = 0; i < hosts.length; i++) wire(hosts[i])
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }
})()
